import { IconWrapper } from '@flexo/general';
import {
  ALERT,
  alertCallbackStore,
  MetaDataStore,
  METADATA,
  RIGHT_DRAWER,
} from '@flexo/reducers';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Button from '../../button/button';
import styles from './../alert.module.scss';

export default function AlertRemoveMemberAppAccount() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const content = t('alerts.remove_member_app_account', { returnObjects: true }) as any;

  async function onConfirm() {
    const data = alertCallbackStore.getData();

    if (data.userId && data.organizationId) {
      try {
        const result = await dispatch(
          METADATA.DisableUserAsync({
            dispatch,
            organizationId: data.organizationId,
            userId: data.userId,
          }) as any
        );

        alertCallbackStore.clearAll();

        if (result?.payload?.success) {
          const currentEntity = MetaDataStore()?.selectedEntity;
          if (currentEntity) {
            dispatch(METADATA.SetSelectedEntityContent({ ...currentEntity, disabled: true } as any));
          }
          dispatch(RIGHT_DRAWER.ResetDrawer({} as any));
        }
      } catch (error) {
        console.error('AlertRemoveMemberAppAccount: error disabling user:', error);
        alertCallbackStore.clearAll();
      }
    } else {
      alertCallbackStore.clearAll();
      dispatch(ALERT.ResetAlert({} as any));
    }
  }

  function onCancel() {
    alertCallbackStore.clearAll();
    dispatch(ALERT.ResetAlert({} as any));
  }

  return (
    <div>
      <div
        id="alert-remove-member-app-account"
        className={`${styles.Alert} ${styles.Alert__Confirm__Credentials__Changes}`}
      >
        <div className={styles.Alert__Title__Negative}>
          <div>
            <IconWrapper iconName="alert" />
            {content.title}
          </div>
          <div className={styles.Alert__Title__Close}></div>
        </div>

        <div className={styles.Alert__Content}>{content.description}</div>

        <div className={`${styles.Alert__Footer__Actions} mt-2`}>
          <Button
            variant="secondary"
            color="grey"
            className={`${styles.Alert__Footer__Actions__Button} ${styles.Alert__Footer__Actions__Button__Cancel}`}
            label={content.cancel}
            onClick={onCancel}
          />
          <Button
            className={`${styles.Alert__Footer__Actions__Button} ${styles.Alert__Footer__Actions__Button__Confirm}`}
            variant="primary"
            color="negative"
            label={content.remove}
            onClick={onConfirm}
          />
        </div>
      </div>
    </div>
  );
}
